import React, { useState, useEffect, useContext } from 'react';
import { Context } from '../../Context'
import { StagePaymentList } from './stagePayment/stagePaymentList'
import { UseLoadingSvg } from '../../hooks/useLoadingSvg'
import { getTransactionAsync, getProductsAsync, sendMail } from '../../services/paymentService'
import { HistoryPayment } from './historyPayment/history'
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Checkbox from "@material-ui/core/Checkbox"
import Grid from "@material-ui/core/Grid";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import ReactTable from "react-table";
import useStyles from '../../styles/GlobalStyles';
import { Modal } from '../../hooks/useModal'
import { Voucher } from '../vouchers/voucher'
import { render } from '@testing-library/react'
import { UseNotification } from '../../hooks/useNotification'
import { getPaymentPDFAsync } from '../../services/historyService';
import routesConfig from 'routesConfig';
import Tooltip from '@material-ui/core/Tooltip';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    
    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </Typography>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

export const Payment = (loadingPSE) => {
  const [loading, setLoading] = useState(true)
  const [products,setProducts] = useState([])
  const [selectedRow, setSelectedRow] = useState([])
  const [isOpen, setOpen] = useState(false)
  const [vouncherData, setVouncherData] = useState([])
  const [validatingUrl, setValidatingUrl] = useState(false)
  const { isAuth, removeAuth } = useContext(Context);
  
  if(window.location.href.includes('GUID') && !validatingUrl){
    setValidatingUrl(true)
    transactionInformation()
  }

  const handleClose = e => {
    setOpen(false)
    window.location.replace(routesConfig.paymentPortalWeb)
  }

  loadingPSE = false;
  var productList = []
  

  async function transactionInformation(){
    const user = JSON.parse(localStorage.getItem('user'))
    if(user != null){
      var paymentId = window.location.href.split('GUID=')
      var paymentInformation = await getTransactionAsync(paymentId[1])
      paymentInformation.data.email = user.Email
      openModal(paymentInformation.data)
      await sendMail(paymentInformation.data)
    } else {
      removeAuth(false)
    }
  } 

  const openModal = (information) => {
    setVouncherData(information)
    setOpen(true)
  }

  async function getProdcutsList () {
    try {
      const user = JSON.parse(localStorage.getItem('user'))
      if(user != null){
        setSelectedRow([])
        var response = await getProductsAsync()
        setLoading(false)
        productList = response.Products
        productList.map(pro => pro.AmountFormatter = pro.Amount.toFixed(2).toString().replace(',', '.').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'))
        setProducts(productList)
      } else {
        removeAuth(false)
      }
    } catch (error) {
      setLoading(false)
      render(<UseNotification titleType={4} messageType={4} />)
    }
  }

	useEffect(() => {
    setLoading(true)
    getProdcutsList()
  }, []);

  const classes = useStyles();

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue)
    
    if(newValue === 0) {
      setLoading(true)
      getProdcutsList()
    }
  };

  async function handlePrint() {
    const user = JSON.parse(localStorage.getItem('user'))
    if(user != null){
      var response = await getPaymentPDFAsync(vouncherData)
      const linkSource = `data:application/pdf;base64,${response}`;
      const downloadLink = document.createElement("a");
      const fileName = "ComprobantePago_" + vouncherData.paymentID + ".pdf";

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    } else {
      removeAuth(false)
    }
  }

  const addPoliza = (row, checked) => {
    const user = JSON.parse(localStorage.getItem('user'))
    if(user != null){
      const elements = [...selectedRow];
      var productList = [...products]
      var policyDocumentNumber = row.ReferenceDesc.split('-')
      var endorsementNumber = policyDocumentNumber[2].split('_')
      row.checked = checked
      if(checked){
          elements.push(row);
          var nextProduct = productList.find(x => (x.ReferenceDesc.includes(endorsementNumber[0])) && parseInt(x.ReferenceDesc.split('-')[3].split('_')[2]) > parseInt(policyDocumentNumber[3].split('_')[2]))
          if(nextProduct != null){
            nextProduct.Locked = false
          } else {
            nextProduct = productList.find(x => (x.ReferenceDesc.includes(endorsementNumber[0])) && parseInt(x.ReferenceDesc.split('-')[2].split('_')[2]) > parseInt(endorsementNumber[2]))
            if(nextProduct != null){
              nextProduct.Locked = false
            }
          }
      }else{
          var nextProduct = productList.find(x => (x.ReferenceDesc.includes(endorsementNumber[0])) && parseInt(x.ReferenceDesc.split('-')[3].split('_')[2]) > parseInt(policyDocumentNumber[3].split('_')[2]))
          if(nextProduct != null){
            nextProduct.Locked = true
          } else {
            nextProduct = productList.filter(x => (x.ReferenceDesc.includes(endorsementNumber[0])) && parseInt(x.ReferenceDesc.split('-')[2].split('_')[2]) > parseInt(endorsementNumber[2]))
            if(nextProduct != null){
              for (let index = 0; index < nextProduct.length; index++) {
                const element = nextProduct[index];
                element.Locked = true
                element.checked = false
                elements.splice(elements.findIndex(x => element.ReferenceDesc == x.ReferenceDesc && x.ExpirationDate == element.ExpirationDate), 1)
              }
            }
          }
          elements.splice(elements.findIndex(x => row.ReferenceDesc == x.ReferenceDesc && x.ExpirationDate == row.ExpirationDate), 1)
      }

      setSelectedRow(elements);
    } else {
      removeAuth(false)
    }
  };

  const columnas = [
    {
      Header : "",
      accessor: "productToPay",
      width: 50,
      Cell : properties => {
        return [
          <Tooltip title={properties.original.Locked ? "Debe seleccionar un anexo anterior" : ""}>
            <span>
              <Checkbox checked={properties.original.checked} color="primary" disabled={properties.original.Locked || properties.original.StatusId == 1} onChange={(e) => { addPoliza(properties.original, e.target.checked)}}></Checkbox>
            </span>
          </Tooltip>
        ]
      },
      sortable : false,
      filterable : false
    },
    {
      Header : "REFERENCIA",
      accessor : "ProductReferenceNumber",
      width: 120,
      Cell : properties => {
        return [
          <p>{properties.original.ProductReferenceNumber}</p>
        ]
      }
    },
    {
      Header : "DESCRIPCION",
      accessor : "ReferenceDesc",
      width: 250,
      Cell : properties => {
        return [
          <p>{properties.original.ReferenceDesc}</p>
        ]
      }
    },
    {
      Header : "VENCIMIENTO",
      accessor : "ExpirationDate",
      width: 100,
      Cell : properties => {
        return [
          <p>{properties.original.ExpirationDate}</p>
        ]
      }
    },
    {
      Header : "MONEDA",
      accessor : "Currency",
      width: 80,
      Cell : properties => {
        return [
          <p>{properties.original.Currency}</p>
        ]
      },
      sortable : true
    },
    {
      Header : "VALOR A PAGAR",
      accessor : "AmountFormatter",
      Cell : properties => {
        return [
          <p>{properties.original.AmountFormatter}</p>
        ]
      },
      sortable : true
    },
    {
      Header : "ESTADO",
      accessor: "Status",
      width: 90,
      Cell: (row) => {
      return <p>{row.original.StatusId == 1 ? "PENDIENTE" : ""}</p>
      },
      sortable : false,
      filterable : false
    }
  ];
  
  return (
    <div className={classes.root}>
      <Grid container className={classes.grid}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.gridItem}>
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" indicatorColor="primary" className={classes.tabs}>
            <Tab label="Cuotas Pendientes" {...a11yProps(0)} className={classes.tab} />
            <Tab label="Histórico de Pagos" {...a11yProps(1)} className={classes.tab} />
          </Tabs>
          <TabPanel value={value} index={0}>
            {
              loading ?
                <UseLoadingSvg />
              :
                <>
                  <Grid container className={classes.grid}>
                    <Grid item xs={12} sm={12} md={7} lg={8} className={classes.gridItem}>
                      <ReactTable
                        data = {products}
                        resolveData = {data => data.map(row => row)}
                        multiSort = {true}
                        expanded = {true}
                        columns = {columnas}
                        selectableRows = {false}
                        style = {{cursor : 'pointer', width : '100%', marginBottom: 15 }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={5} lg={4} className={classes.gridItem}>
                      <StagePaymentList paymentArray = {[...selectedRow]} />
                    </Grid>
                  </Grid>
                </>
            }            
          </TabPanel>
          <TabPanel value={value} index={1}>
            <HistoryPayment />
          </TabPanel>
        </Grid>
      </Grid>
      <Modal isOpen = {isOpen} 
             maxWidth = "md" 
             scroll = {true} 
             actionsFooter
             handleClose={handleClose}
             handlePrint={handlePrint}>
        <Voucher {...vouncherData} />
      </Modal>
    </div>
  )
}